import { combineReducers } from "redux";
import reportListReducer from "../components/reports/components/reportList/reducers/reportListReducer";
import pptCartReducer from "../components/pptCart/pptCartReducer";
import powerBIReportReducer from "../components/powerBI/components/report/reducers/reportReducer";
import staticContentReducer from "../components/staticContent/reducers/staticContentReducer";
import topLevelNavReducer from "../components/topLevelNav/reducers/topLevelNavReducer";
import authReducer from "../reducers/authReducer";
import appReducer from "../reducers/appReducer";
import breadcrumbReducer from "../reducers/breadcrumbReducer";
import filesReducer from "../components/files/reducers/filesReducer";
import mdmReducer from "../components/mdm/reducers/mdmReducer";
import insightsDiscoveryReducer from "../components/insightsDiscovery/reducers/insightsDiscoveryReducer";
import pbiMgmtReducer from "../components/pbiMgmt/pbiMgmtReducer";
import notificationsReducer from "../components/notifications/notificationsReducer";
import userManagementReducer from "../components/userManagement/reducers/userManagementReducer";
import groupReducer from "../components/userManagement/reducers/groupReducer";
import rptSubscriptionReducer from "../components/reportSubscriptions/reducers/reportSubscriptionReducer";
import homePageStatusReducer from "../components/reports/components/reducers/homePageStatusReducer";

export default combineReducers({
  app: appReducer,
  auth: authReducer,
  breadcrumb: breadcrumbReducer,
  reportList: reportListReducer,
  powerBIReport: powerBIReportReducer,
  scReport: staticContentReducer,
  topLevelNav: topLevelNavReducer,
  files: filesReducer,
  mdm: mdmReducer,
  insightsDiscovery: insightsDiscoveryReducer,
  pptCart: pptCartReducer,
  notifications: notificationsReducer,
  pbiMgmt: pbiMgmtReducer,
  userManagementReducer: userManagementReducer,
  groupReducer: groupReducer,
  rptSubscriptions: rptSubscriptionReducer,
  homePageStatus: homePageStatusReducer,
});
